export const messages = {
  de: {
    app: {
      title: "OMM Process Assessment Tool",
      furtherInformationOrInterest:
        "Für weitere Informationen oder bei Interesse an einem Zugang kontaktieren Sie bitte",
      infoMailLink: "info@omm-solutions.de",
      navigation: {
        names: {
          manageAccounts: "Accounts verwalten",
          compareAssessments: "Bewertungen vergleichen",
          settings: "Einstellungen",
          organization: "Organization",
          processes: "UiPath Prozesse"
        }
      }
    },
    dialogs: {
      login: {
        onError: "Login fehlgeschlagen. Die angegebenen Daten sind fehlerhaft."
      },
      deleteEntry: {
        confirmMessage: "Eintrag entfernen",
        explanation:
          "Soll der Prozess {entryName} wirklich gelöscht werden? <br> Dieser Schritt kann nicht rückgängig gemacht werden!",
        onError:
          "{entryName} konnte nicht gelöscht werden. <br> Versuchen sie es erneut."
      },
      createAssessment: {
        confirmMessage: "Neuen Prozess erfassen",
        onSuccess: "{processname} wurde erfolgreich erstellt."
      },
      implementation: {
        shallBeMarkedAsImplemented:
          "Soll der Prozess als umgesetzt markiert werden?",
        shallBeMarkedAsNotImplemented:
          "Soll der Prozess als nicht umgesetzt markiert werden?"
      },
      createAccount: {
        confirmMessage: "Account Erstellen",
        onSuccess: "User: {user} wurde erfolgreich erstellt.",
        onError:
          "Beim Erstellen des Accounts ist ein Fehler aufgetreten. Versuchen sie es erneut."
      },
      updateAccount: {
        title: "Account Bearbeiten",
        onSuccess: "User: {user} wurde erfolgreich bearbeitet.",
        onError:
          "Beim Bearbeiten des Accounts ist ein Fehler aufgetreten. Versuchen sie es erneut"
      }
    },
    views: {
      accountAdministration: {
        tooltip: {
          username: "Name des Nutzers",
          organization: "Organisation zu der der Account gehört",
          roles: "Rollen die der Nutzer inne hat",
          id: "ID des Nutzers",
          assessmentNumber: "Anzahl der erstellten Prozesse"
        },
        buttons: {
          newAccount: "Neuer Account"
        }
      },
      comparisonView: {
        allProcesses: "Alle Prozesse",
        implemented: "umgesetzt",
        implement: "Umsetzen",
        tooltips: {
          freedCapacity:
            "Anzahl der Stunden, die jährlich für spannende Tätigkeiten verwendet werden könnten.",
          errorReduction:
            "Gibt an um wie viel Prozent die, durch Mitarbeiter verursachten, Fehler verrringert werden können, wenn der Prozess automatisiert wird.",
          effortToImplement:
            "Die Anzahl der Arbeitsstunden um den Prozess zu automatisieren. (reiner Umsetzungsaufwand exkl. Projektmanagement, Kommunikation, ...)",
          easeOfImplementation: "Gibt die Umsetzungskomplexität an.",
          benefit:
            "Gibt den Nutzen an, den eine Automatisierung des Prozesses mit sich bringt. Je höher der Wert, desto größer der Nutzen."
        }
      },
      settingsView: {
        name: "Einstellungen",
        tabs: {
          userData: "Nutzerdaten",
          userSettings: "Nutzereinstellungen",
          appSettings: "App-Einstellungen",
          appLanguage: "Spracheinstellungen",
          currentLanguage: "aktuelle Sprache:",
          defaultLanguage: "Standard-Sprache:"
        }
      },
      forgotPassword: {
        forgotten: "Passwort Vergessen",
        forgottenInfo:
          "Falls sie ihr Passwort vergessen haben, geben sie ihren Nutzername ein um ein Passwort Reset anzufordern."
      },
      resetPassword: {
        reset: "Passwort Reset",
        password: "Geben sie ein neues Passwort ein",
        passwordConfirmation: "Passwort Bestätigung"
      }
    },
    components: {
      bubbleChart: {
        formattedBubbleChartData:
          "<strong>{entryName}</strong><br> Komplexität: <strong>{easeOfImplementation}</strong><br> Nutzen: <strong>{benefitSuitability}</strong><br> Kapa-freisetz.: <strong>{freedCapacity}h</strong>",
        highBenefit: "Hoher Mehrwert",
        lowSuitability: "Geringe Eignung",
        highComplexity: "Hohe Komplexität",
        lowComplexity: "Geringe Komplexität"
      },
      editOrganization: {
        orchestratorSuccess:
          "Die Orchestrator-Daten wurden auf dem Server erfolgreich validiert.",
        orchestratorWaiting:
          "Die Orchestrator-Daten wurden noch nicht verifiziert.",
        placeholder: {
          organizationName: "Umbrella Corp",
          orchestratorHost: "z.B. https://orchestrator.omm.cloud",
          orchestratorTenantName: "z.B. omm-solutions",
          orchestratorTechnicalUserName: "z.B. technicalFormUser",
          orchestratorTechnicalPassword: "wird ignoriert, wenn leer gelassen",
          clientId: "z.B. e55506d3-40fa-42ed-b70c-90510fd3760b",
          clientSecret: "z.B. 7AFc4JDGAplJ3i4U15mm3uDn62jK93n5",
          accountLogicalName: "z.B. omm-solutions",
          apiKey: "z.B. SGVsbG8gV29ybGQ="
        },
        label: {
          organizationName: "Organisationsname",
          orchestratorHost: "Orchestrator Host",
          orchestratorTenantName: "Orchestrator Tenant Name",
          orchestratorTechnicalUserName: "Orchestrator Technischer Nutzername",
          orchestratorTechnicalPassword:
            "Orchestrator Technischer Nutzer Passwort",
          clientId: "Orchestrator Client Id",
          clientSecret: "Orchestrator Client Secret",
          accountLogicalName: "Orchestrator logischer Account Name",
          apiKey: "Orchestrator API Key"
        },
        saveAndTest: "Speichern und Testen"
      }
    },
    generics: {
      terms: {
        evaluation: "Auswertung",
        frequency: "Häufigkeit",
        complexity: "Komplexität",
        easeOfImplementation: "Komplexität",
        benefit: "Mehrwert",
        benefit2: "Nutzen",
        suitabilityToAutomize: "Nutzen/Eignung zur Automatisierung",
        freedCapacity: "Freigesetzte Kapazitäten (Stunden / Jahr)",
        freedCapacityShort: "Kapa-freisetz.: ",
        errorReduction: "Fehlerreduktion",
        effortToImplement: "Aufwand (Stunden)",
        averageHandlingTimeReduction:
          "Durchschnittliche Nutzungsdauerverringerung",

        information: "Information",
        explanation: "Erklärung",
        warning: "Achtung",
        process: "Prozess | Prozesse",
        username: "Nutzername",
        password: "Passwort",
        account: "Account",
        organization: "Organisation",
        email: "Email",
        id: "ID",
        creator: "Ersteller",
        firstname: "Vorname",
        lastname: "Nachname",
        department: "Abteilung",
        noDepartment: "Ohne Abteilung",
        roles: "Rollen",
        nameOfProcess: "Name des Prozesses",
        optional: {
          firstname: "Vorname (optional)",
          lastname: "Nachname (optional)",
          nameOfDepartment: "Name der Abteilung (optional)",
          password: "Passwort (optional)"
        },
        baseInfo: "Basisdaten:",
        createdAt: "erstellt am: ",
        data: "Daten: ",
        outputs: "Ergebnisse",
        assessmentData: "Auswertungsdaten"
      },
      measurements: {
        low: "gering",
        mediumLow: "mäßig",
        medium: "normal",
        high: "hoch",
        veryHigh: "sehr hoch"
      },
      buttons: {
        confirmation: "Ok",
        next: "Weiter",
        back: "Zurück",
        cancel: "Abbrechen",
        manageAccounts: "Accounts verwalten",
        compareAssessments: "Bewertungen vergleichen",
        save: "Speichern",
        delete: "Löschen",
        grouping: "Gruppieren",
        submit: "Absenden",
        newProcess: "Neuer Prozess",
        login: "Login",
        download: "Herunterladen",
        export: "Exportieren"
      }
    },
    excel: {
      shallBeDownloaded:
        "Soll das Assessment als Excel heruntergeladen werden?",
      willContain: "Die Excel-datei wird folgende Assessments enthalten:"
    },
    quickAssistant: {
      optionalDepartmentNotice:
        "Optional können Sie den Prozess einer Abteilung zuordnen.",
      processFrequencyQuestion: "Wie häufig wird der Prozess ausgeführt?",
      processDurationQuestion: "Wie lange dauert die Durchführung im Schnitt?",
      processStepsQuestion: "Wieviele Schritte umfasst der Prozess?",
      processStepsExplanation: "Mausklicks, Tastatureingaben, etc...",
      evaluationFor: "Auswertung für {processname}",
      toComparison: "Zum Vergleich"
    },
    implementationMotivator: {
      partSentence1: "Insgesamt besteht das Potential, um...",
      partSentence2: "zu automatisieren und ...",
      partSentence3: "Arbeitsstunden für spannende Aufgaben freizusetzen!"
    },
    numbers: {
      counting: {
        1: "ein",
        2: "zwei",
        3: "drei",
        4: "vier",
        5: "fünf",
        6: "sechs",
        7: "sieben",
        8: "acht",
        9: "neun",
        10: "zehn"
      }
    },
    time: {
      hours: "Stunden"
    },
    messages: {
      tryAgainLater:
        "Leider ist ein Fehler aufgetreten. Bitte versuchen sie es später nochmal.",
      assessmentCreationOrUpdateError:
        "Beim Erstellen oder Bearbeiten ist ein Fehler unterlaufen. Bitte versuchen sie es erneut.",
      enterNameOfProcess:
        "Bitte geben Sie den Namen des Prozesses ein, den Sie erfassen möchten.",
      pleaseEnterProcessName: "Bitte den Namen des Prozesses eingeben.",
      enterProcessesForEvaluation:
        "Tragen Sie jetzt ihre Prozesse ein und erhalten sofort eine Auswertung!",
      momentPlease: "Einen Moment bitte, ihre Anfrage wird bearbeitet.",
      loginFailedDueToData:
        "Login fehlgeschlagen. Die angegebenen Daten sind fehlerhaft.",
      nameNeededToSaveAssessment:
        "Sie müssen einen Namen angeben um einen Eintrag zu speichern oder zu verändern.",
      enterUsername: "Bitte geben sie ihren Nutzername ein.",
      resetLinkNotification:
        "Ein Password Reset Link wurde an ihre Email geschickt.",
      passwordWasChanged:
        "Ihr Password wurde geändert. Bitte melden sie sich mit ihren neuen Zugangsdaten an um die App weiter zu benutzen.",
      noPasswordMatch:
        "Die eingegebene Passwörter sind nicht gleich. Bitte überprüfen sie die Eingaben und versuchen es dann nochmal.",
      enterNewPassword: "Bitte geben sie ein neues Passwort ein.",
      enterPasswordTwice: "Geben sie ein neues Passwort zwei Mal ein.",
      fillAllFields:
        "Bitte füllen sie alle Felder aus bevor sie einen Account erstellen."
    },
    times: {
      monthly: "monatlich",
      timesMonthly: "{count} mal monatlich",
      weekly: "wöchentlich",
      timesWeekly: "{count} mal wöchentlich",
      daily: "täglich",
      timesDaily: "{count} mal täglich"
    },
    questionData: {
      inputDataStructure: {
        type: "Eingabetypen",
        text: "Wie sieht der Großteil Ihrer Dateneingaben aus?",
        explanation:
          "Digital: alle Daten, die auf einer Maschine [Server, Laptop, IOT-Geräte] gespeichert werden können.\n Strukturierte Daten: haben ein vorhersagbares Format, existieren in festen Feldern (z.B. eine xls-Zelle oder ein Feld in einem Formular) und sind über Suchalgorithmen leicht auffindbar.\n Stellen Sie sich Ihre strukturierten Daten wie folgt vor:\n Excel, Tabellen mit fester Struktur, Datenbanken, aus denen Sie Ihre Informationen mit Hilfe einer Suchfunktion leicht extrahieren können.\n Unstrukturierte Daten: können ihre eigene interne Struktur haben, aber diese ist nicht sehr vorhersehbar.\n Beispiele: Webprotokolle, Multimedia-Inhalte, Interaktionen mit dem Kundendienst und Daten aus sozialen Medien.",
        answerPossibilities: {
          notDigitalAndUnstructured: "Nicht digital und unstrukturiert",
          notDigitalAndStructured: "Nicht digital und strukturiert",
          digitalAndUnstructured: "Digital und unstrukturiert",
          digitalAndStructured: "Digital und strukturiert"
        }
      },
      processStability: {
        type: "Prozess Stabilität",
        text: "Wie wird sich Ihr Prozess in den nächsten 6 Monaten ändern?",
        explanation:
          "Denken Sie über Änderungen der folgenden Art nach:\n - anstehende Gesetzesänderungen, die die Regeln/Logik des Prozesses verändern könnten.\n - Branchenveränderungen, die das Geschäftsmodell und damit die Regeln des Prozesses verändern könnten.",
        answerPossibilities: {
          noChange: "Keine Änderungen erwartet",
          smallChange: "Sehr geringe Änderung",
          someChange: "Manche Änderungen",
          mediumChange: "Mittlere Änderungen",
          significantChange: "Signifikante Änderungen"
        }
      },
      applicationStability: {
        type: "Stabilität der Anwendung",
        text:
          "Wie werden sich Ihre Applikationen in den nächsten 6 Monaten ändern?",
        explanation:
          "Denken Sie nicht nur an Anwendungen, sondern auch an Schnittstellen, Menüs in Apps und Berichten. ",
        answerPossibilities: {
          noChange: "Keine Änderungen erwartet",
          smallChange: "Sehr geringe Änderung",
          someChange: "Manche Änderungen",
          mediumChange: "Mittlere Änderungen",
          significantChange: "Signifikante Änderungen"
        }
      },
      processFrequency: {
        type: "Vorteile",
        text: "Wie ist die Häufigkeit des Prozesses?",
        explanation: "",
        answerPossibilities: {
          daily: "{count} mal täglich ",
          weekly: "{count} mal wöchentlich",
          monthly: "{count} mal monatlich",
          quarterly: "vierteljährlich",
          annualy: "jährlich"
        }
      },
      frequencyVolume: {
        type: "Vorteile",
        text:
          "Wie hoch ist das Transaktionsvolumen/Häufigkeit (Anzahl der Durchläufe/gewählte Häufigkeit des Prozesses)?",
        explanation:
          "Wenn der Prozess z.B. wöchentlich stattfindet, dann müssen wir das Volumenkennen, das im Durchschnitt während einer Woche passiert."
      },
      averageRuntime: {
        type: "Vorteile",
        text:
          "Wie lange dauert es durchschnittlich, bis der Prozess einmal ausgeführt wird (durchschnittliche Bearbeitungszeit/Transaktion)?",
        explanation:
          "Bitte quantifizieren Sie die durchschnittliche Bearbeitungszeit in Minuten, z.B. wenn 4 Stunden, dann fügen Sie 240 ein."
      },
      humanErrorPercentage: {
        type: "Vorteile",
        text:
          "Wie hoch ist die durchschnittliche Zahl der menschlichen Fehler?",
        explanation:
          "Welcher Prozentsatz der Fehler wird von Menschen verursacht, die an dem Prozess beteiligt sind?"
      },
      processPeaks: {
        type: "Vorteile",
        text: "Wie würden Sie die Spitzenwerte des Prozesses charakterisieren?",
        explanation:
          "Regelmäßig: (z.B. Monatsabschluss), die mehrere Tage oder Wochen hintereinander dauern und die Auslastung der Teamkapazität um > 20%.\n Selten, aber vorhersehbar: (z.B. Winterferien/Jahresschluss), die mehrere Tage oder Wochen hintereinander dauern und die Auslastung der Teamkapazität um > 20%",
        answerPossibilities: {
          noPeaks: "Der Prozess hat keine Spitzenwerte",
          regularPeaks: "Regelmäßig",
          rareAndPredictable: "Seltenes, aber vorhersehbares Ereignis",
          rareAndUnpredictable: "Seltenes und schwer vorherzusagendes Ereignis"
        }
      },
      processSteps: {
        type: "Prozess-Komplexität",
        text: "Wie viele Schritte umfasst der Prozess?",
        explanation: "",
        answerPossibilities: {
          lessThanTen: "<10",
          tenToFifteen: "10-15",
          fifteenToTwentyfive: "15-25",
          twentyfiveToFourty: "25-40",
          moreThanFourty: ">40"
        }
      },
      decisionDifficulty: {
        type: "Prozess-Komplexität",
        text:
          "Wie schwierig sind die Entscheidungen, die Sie treffen müssen, um den Prozess abzuschließen?",
        explanation: "",
        answerPossibilities: {
          noDecisions:
            "Der Prozess ist linear - es müssen keine Entscheidungen getroffen werden.",
          complexDecisions: "Der Prozess beinhaltet komplexe Entscheidungen",
          simpleDecisions:
            "Der Prozess beinhaltet einfache Entscheidungen (Ja/Nein-Typ)"
        }
      },
      unfinishedProcessPercentage: {
        type: "Prozess-Komplexität",
        text:
          "Wie hoch ist der durchschnittliche Prozentsatz der Fälle, in denen Sie nicht in der Lage sind, den gesamten Prozess abzuschließen?",
        explanation:
          "Entweder weil Sie die Eingabe einer anderen Person benötigen oder weil Sie in eine Situation geraten, die nicht durch eine klare Regel abgedeckt ist."
      },
      applicationsUsed: {
        type: "Prozess-Komplexität",
        text:
          "Wie hoch ist die Anzahl der Anwendungen, die Sie für das Verfahren verwenden?",
        explanation: "",
        answerPossibilities: {
          one: "1 Anwendung",
          twoToThree: "2-3 Anwendungen",
          fourToFive: "4-5 Anwendungen",
          moreThanFive: ">5 Anwendungen"
        }
      },
      remoteDesktopApplication: {
        type: "Prozess-Komplexität",
        text: "Wird auf eine der Anwendungen über VDI zugegriffen?",
        explanation: "",
        answerPossibilities: {
          yes: "Ja",
          no: "Nein"
        }
      },
      digitalInputPercentage: {
        type: "Eingabetypen",
        text: "Welcher Prozenzsatz ihrer Daten ist digital?",
        explanation: ""
      },
      inputScanned: {
        type: "Eingabetypen",
        text: "Ist einer Ihrer digitalen Eingänge gescannt?",
        explanation: "",
        answerPossibilities: {
          yes: "Ja",
          no: "Nein"
        }
      },
      amountOfStructuredInputData: {
        type: "Eingabetypen",
        text: "Wieviel % Ihrer Eingabedaten sind strukturiert?",
        explanation:
          "Strukturierte Daten: haben ein vorhersehbares Format, existieren in festen Feldern (z.B. einer xls-Zelle oder einem Feld in einem Formular) und sind über Suchalgorithmen leicht auffindbar.\n Stellen Sie sich Ihre strukturierten Daten wiefolgt vor:\n Excel, Tabellen mit fester Struktur, Datenbanken, aus denen Sie Ihre Informationen über eine Suchfunktion leicht extrahieren können.\n Beispiele:\n Wenn Ihre Eingaben aus 5 Excel-Dateien/oder ERP-Berichten bestehen, dann sind 100% Ihrer Daten strukturiert, während Ihre Eingaben aus 4 Excel-Dateien/ERP-Berichten und 1 E-Mail-Text bestehen, dann sind 80% Ihrer Daten strukturiert.",
        answerPossibilities: {
          smallerThanFourty: "<40%",
          fourtyToSixty: "40-60%",
          sixtyToEighty: "60-80%",
          biggerThanEighty: ">80%"
        }
      }
    }
  },

  en: {
    app: {
      title: "OMM Process Assessment Tool",
      furtherInformationOrInterest:
        "For further information or if you're interested in an account, feel free to contact",
      infoMailLink: "info@omm-solutions.de",
      navigation: {
        names: {
          manageAccounts: "manage accounts",
          compareAssessments: "compare assessments",
          settings: "settings",
          organization: "Organization",
          processes: "UiPath Processes"
        }
      }
    },
    dialogs: {
      login: {
        onError: "Login failed. The login credentials are incorrect."
      },
      deleteEntry: {
        confirmMessage: "delete entry",
        explanation:
          "Should the process {entryName} really be deleted? <br> This can not be reversed!",
        onError: "{entryName} couldn't be deleted. <br> Please try it again."
      },
      createAssessment: {
        confirmMessage: "Register new process",
        onSuccess: "{processname} was successfully created."
      },
      implementation: {
        shallBeMarkedAsImplemented:
          "Shall the process be marked as implemented?",
        shallBeMarkedAsNotImplemented:
          "Shall the process be marked as not implemented?"
      },
      createAccount: {
        confirmMessage: "Create account",
        onSuccess: "User: {user} was successfully created.",
        onError: "An error occured while creating the account. Try it again."
      },
      updateAccount: {
        title: "Edit Account",
        onSuccess: "User: {user} has been sucessfully updated.",
        onError: "An error occured while updating the account. Try it again"
      }
    },
    views: {
      accountAdministration: {
        tooltip: {
          username: "Name of the user",
          organization: "Organization to which the account belongs",
          roles: "Roles that the user holds",
          id: "Id of the user",
          assessmentNumber: "Number of created assessments"
        },
        buttons: {
          newAccount: "new account"
        }
      },
      comparisonView: {
        allProcesses: "all processes",
        implemented: "implemented",
        implement: "implement",
        tooltips: {
          freedCapacity:
            "Amount of hours that could be used annually for exciting activities.",
          errorReduction:
            "Specifies the percentage by which errors, caused by employees, can be reduced if the process is automated.",
          effortToImplement:
            "The amount of work-hours needed to automize the process. (pure implementation effort excl. projectmanagement, communication, ...)",
          easeOfImplementation: "Indicates implementation complexity.",
          benefit:
            "Indicates the benefits of automating the process. The higher the value, the greater the benefit."
        }
      },
      settingsView: {
        name: "Settings",
        tabs: {
          userData: "Userdata",
          userSettings: "User-settings",
          appSettings: "App-settings",
          appLanguage: "Language-settings",
          currentLanguage: "Current Language:",
          defaultLanguage: "Default Language:"
        }
      },
      forgotPassword: {
        forgotten: "forgot password",
        forgottenInfo:
          "If you have forgotten your password, enter your username to request a password reset."
      },
      resetPassword: {
        reset: "reset password",
        password: "Enter a new Password",
        passwordConfirmation: "confirm password"
      }
    },
    components: {
      bubbleChart: {
        formattedBubbleChartData:
          "<strong>{entryName}</strong><br> Complexity: <strong>{easeOfImplementation}</strong><br> Benefit: <strong>{benefitSuitability}</strong><br> Capacity freed: <strong>{freedCapacity}h</strong>",
        highBenefit: "high benefit",
        lowSuitability: "low suitability",
        highComplexity: "high complexity",
        lowComplexity: "low complexity"
      },
      editOrganization: {
        orchestratorSuccess:
          "The orchestrator data was successfully validated on the server.",
        orchestratorWaiting: "The orchestrator data has not yet been verified.",
        placeholder: {
          organizationName: "Umbrella Corp",
          orchestratorHost: "e.g. https://orchestrator.omm.cloud",
          orchestratorTenantName: "e.g.. omm-solutions",
          orchestratorTechnicalUserName: "e.g. technicalFormUser",
          orchestratorTechnicalPassword: "will be ignored if left blank",
          clientId: "e.g. e55506d3-40fa-42ed-b70c-90510fd3760b",
          clientSecret: "e.g. 7AFc4JDGAplJ3i4U15mm3uDn62jK93n5",
          accountLogicalName: "e.g. omm-solutions",
          apiKey: "e.g. SGVsbG8gV29ybGQ="
        },
        label: {
          organizationName: "Organizationname",
          orchestratorHost: "Orchestrator Host",
          orchestratorTenantName: "Orchestrator Tenant Name",
          orchestratorTechnicalUserName: "Orchestrator technical Username",
          orchestratorTechnicalPassword: "Orchestrator technical User-password",
          clientId: "Orchestrator client id",
          clientSecret: "Orchestrator client secret",
          accountLogicalName: "Orchestrator logical name",
          apiKey: "Orchestrator API Key"
        },
        saveAndTest: "Save and test"
      }
    },
    generics: {
      terms: {
        evaluation: "Evaluation",
        frequency: "Frequency",
        complexity: "Complexity",
        easeOfImplementation: "Ease of implementation",
        benefit: "Benefit",
        benefit2: "Profit",
        suitabilityToAutomize: "Suitability to automize",
        freedCapacity: "Freed capacity (hours / year)",
        freedCapacityShort: "capa-freed.: ",
        errorReduction: "Error-reduction",
        effortToImplement: "Effort to implement (hours)",
        averageHandlingTimeReduction: "average handling-time-reduction",

        information: "Information",
        explanation: "Explanation",
        warning: "Warning",
        process: "Process | processes",
        username: "Username",
        password: "Password",
        account: "Account",
        organization: "Organization",
        email: "E-mail",
        id: "ID",
        creator: "Creator",
        firstname: "Firstname",
        lastname: "Lastname",
        department: "Department",
        noDepartment: "no department",
        roles: "Roles",
        nameOfProcess: "Name of the process",
        optional: {
          firstname: "Firstname (optional)",
          lastname: "Lastname (optional)",
          nameOfDepartment: "Name of department (optional)",
          password: "Password (optional)"
        },
        baseInfo: "Base-data:",
        createdAt: "created at: ",
        data: "data: ",
        outputs: "Outputs:",
        assessmentData: "Assessmentdata"
      },
      measurements: {
        low: "low",
        mediumLow: "moderate",
        medium: "medium",
        high: "high",
        veryHigh: "very high"
      },
      buttons: {
        confirmation: "Confirm",
        next: "Next",
        back: "Back",
        cancel: "Cancel",
        save: "Save",
        delete: "Delete",
        grouping: "Group",
        submit: "Submit",
        newProcess: "New process",
        login: "Login",
        download: "Download",
        export: "Export"
      }
    },
    excel: {
      shallBeDownloaded: "Shall the assessment be downloaded as an excel-file?",
      willContain: "The excel-file will contain the following assessments:"
    },
    quickAssistant: {
      optionalDepartmentNotice:
        "Optionally, you can assign the process to a department.",
      processFrequencyQuestion: "How often is the process executed?",
      processDurationQuestion: "Ho long odes the execution take on average?",
      processStepsQuestion: "How many steps are involved in the process?",
      processStepsExplanation: "Mouseclicks, Keystrokes, etc...",
      evaluationFor: "Evaluation for {processname}",
      toComparison: "To comparison"
    },
    implementationMotivator: {
      partSentence1: "There is a total potential to automate...",
      partSentence2: "and free up to ...",
      partSentence3: "working hours for exciting tasks!"
    },
    numbers: {
      counting: {
        1: "one",
        2: "two",
        3: "three",
        4: "four",
        5: "five",
        6: "six",
        7: "seven",
        8: "eight",
        9: "nine",
        10: "ten"
      }
    },
    time: {
      hours: "hours"
    },
    messages: {
      tryAgainLater: "An error occured. Please try it again later.",
      assessmentCreationOrUpdateError:
        "An error occured while creating or editing an assessment. Please try again.",
      enterNameOfProcess:
        "Please enter the name of the process you want to register.",
      pleaseEnterProcessName: "Please enter the name of the process.",
      enterProcessesForEvaluation:
        "Register your processes now and immediately get an evaluation!",
      momentPlease: "One moment please your request is being processed.",
      loginFailedDueToData: "Login failed. The specified data is incorrect.",
      nameNeededToSaveAssessment:
        "You need to specify a name to save or edit an assessment",
      enterUsername: "Please enter your username.",
      resetLinkNotification:
        "A password-reset link has been sent to your e-mail adress.",
      passwordWasChanged:
        "Your password was changed. Please log in with your new access data to continue using the app.",
      noPasswordMatch:
        "The passwords entered are not identical. Please check your entries and try again.",
      enterNewPassword: "Please enter your new password.",
      enterPasswordTwice: "Enter your new password twice.",
      fillAllFields: "Please fill out all fields before creating an account."
    },
    times: {
      monthly: "monthly",
      timesMonthly: "once per month | {count} times per month",
      weekly: "weekly",
      timesWeekly: "once per week | {count} times per week",
      daily: "daily",
      timesDaily: "once per day | {count} times per day"
    },

    questionData: {
      inputDataStructure: {
        type: "Input Types",
        text: "What does the majority of your data input look like??",
        explanation:
          "Digital: any data that can be stored on a machine [server, laptop, IOT devices]. Structured data: has a predictable format, exists in fixed fields (e.g. an xls cell or a field in a form) and is easily detectable via search algorithms. Think about your structured data as: excels, tables with fixed structure, databases where you can easily extract your information through a search function. Unstructured data: may have its own internal structure, but this is not highly predictable. Examples: web logs, multimedia content, customer service interactions and social media data. ",
        answerPossibilities: {
          notDigitalAndUnstructured: "not digital and unstructured",
          notDigitalAndStructured: "not digital and structured",
          digitalAndUnstructured: "digital and unstrctured",
          digitalAndStructured: "digital and strctured"
        }
      },
      processStability: {
        type: "Process Stability",
        text: "How will your process change in the next 6 months?",
        explanation:
          "Think about changes of the following type: - legislative changes that are upcoming and could change the rules/logic of the process. - industry shifts that could change the business model and hence the rules of the process",
        answerPossibilities: {
          noChange: "no changes expected",
          smallChange: "minimal changes",
          someChange: "some changes",
          mediumChange: "medium changes",
          significantChange: "significant changes"
        }
      },
      applicationStability: {
        type: "Application Stability",
        text: "How will your application change in the next 6 months?",
        explanation:
          "Think about not only applications but also interfaces, menus in apps and reports. ",
        answerPossibilities: {
          noChange: "no changes expected",
          smallChange: "minimal changes",
          someChange: "some changes",
          mediumChange: "medium changes",
          significantChange: "significant changes"
        }
      },
      processFrequency: {
        type: "Benefits",
        text: "What is the frequency of of the process?",
        explanation: "",
        answerPossibilities: {
          daily: "once per day | {count} times per day ",
          weekly: "once per week | {count} times per week",
          monthly: "once per month | {count} times per month",
          quarterly: "quarterly",
          annualy: "annualy"
        }
      },
      frequencyVolume: {
        type: "Benefits",
        text:
          "What is the transaction volume / frequency (number of runs / selected frequency of the process)?",
        explanation:
          "E.g. If the process happens weekly please then we need to know the volume that happens on average during a week."
      },
      averageRuntime: {
        type: "Benefits",
        text:
          "How long does it take on average until the process is executed once (average processing time / transaction)?",
        explanation:
          "Please quantify the average handling time in minutes e.g. if 4 hours then insert 240"
      },
      humanErrorPercentage: {
        type: "Benefits",
        text: "What is the average number of human errors?",
        explanation:
          "Welcher Prozentsatz der Fehler wird von Menschen verursacht, die an dem Prozess beteiligt sind?"
      },
      processPeaks: {
        type: "Benefits",
        text: "How would you characterize the peaks of the process?",
        explanation:
          "Regelmäßig: (z.B. Monatsabschluss), die mehrere Tage oder Wochen hintereinander dauern und die Auslastung der Teamkapazität um > 20%.\n Selten, aber vorhersehbar: (z.B. Winterferien/Jahresschluss), die mehrere Tage oder Wochen hintereinander dauern und die Auslastung der Teamkapazität um > 20%",
        answerPossibilities: {
          noPeaks: "the process has no peaks",
          regularPeaks: "average peaks",
          rareAndPredictable: "rare but predictable peaks",
          rareAndUnpredictable: "rare and unpredictable peaks"
        }
      },
      processSteps: {
        type: "Process Complexity",
        text: "How many steps are involved in the process?",
        explanation: "",
        answerPossibilities: {
          lessThanTen: "<10",
          tenToFifteen: "10-15",
          fifteenToTwentyfive: "15-25",
          twentyfiveToFourty: "25-40",
          moreThanFourty: ">40"
        }
      },
      decisionDifficulty: {
        type: "Process Complexity",
        text:
          "How difficult are the decisions you have to make to complete the process?",
        explanation: "",
        answerPossibilities: {
          noDecisions: "The process is linear - no decisions need to be made.",
          complexDecisions: "The process involves complex decisions",
          simpleDecisions:
            "The processs involves simple decisions (Yes/No-type)"
        }
      },
      unfinishedProcessPercentage: {
        type: "Process Complexity",
        text:
          "What is the average percentage of times that you are unable to complete the entire process?",
        explanation:
          "Either because you need someone else's input or because you find yourself in a situation that is not covered by a clear rule."
      },
      applicationsUsed: {
        type: "Process Complexity",
        text:
          "What is the number of applications that you use for the procedure?",
        explanation: "",
        answerPossibilities: {
          one: "1 application",
          twoToThree: "2-3 applications",
          fourToFive: "4-5 applications",
          moreThanFive: ">5 applications"
        }
      },
      remoteDesktopApplication: {
        type: "Process Complexity",
        text: "Wird auf eine der Anwendungen über VDI zugegriffen?",
        explanation: "",
        answerPossibilities: {
          yes: "Ja",
          no: "Nein"
        }
      },
      digitalInputPercentage: {
        type: "Input types",
        text: "Welcher Prozenzsatz ihrer Daten ist digital?",
        explanation: ""
      },
      inputScanned: {
        type: "Input types",
        text: "Ist einer Ihrer digitalen Eingänge gescannt?",
        explanation: "",
        answerPossibilities: {
          yes: "Ja",
          no: "Nein"
        }
      },
      amountOfStructuredInputData: {
        type: "Input types",
        text: "Wieviel % Ihrer Eingabedaten sind strukturiert?",
        explanation:
          "Structured data: has a predictable format, exists in fixed fields (e.g. an xls cell or a field in a form) and is easily detectable via search algorithms. Think about your structured data as: excels, tables with fixed structure, databases where you can easily extract your information through a search function. Examples: if your inputs consist of 5 excel files/or ERP reports then 100% of your data is structured, whereas if your input consists of 4 excel files/ERP reports and 1 e-mail text then 80% of your data is structured. ",
        answerPossibilities: {
          smallerThanFourty: "<40%",
          fourtyToSixty: "40-60%",
          sixtyToEighty: "60-80%",
          biggerThanEighty: ">80%"
        }
      }
    }
  }
};
